import { render, staticRenderFns } from "./AttendeeInfo.vue?vue&type=template&id=5c3a741f&scoped=true&"
import script from "./AttendeeInfo.vue?vue&type=script&lang=js&"
export * from "./AttendeeInfo.vue?vue&type=script&lang=js&"
import style0 from "./AttendeeInfo.vue?vue&type=style&index=0&id=5c3a741f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a741f",
  null
  
)

export default component.exports